import React, { useState, useEffect, useRef, useCallback } from "react";
import TextField from "@material-ui/core/TextField";
import loadMoreIcon from "../../../assets/load-more.svg";
import { Spinner } from "react-bootstrap";
import { debounce, isArray, isEmpty, isNull } from "lodash";
import styled from "styled-components";
import { makeStyles, styled as materialStyle } from "@material-ui/core/styles";
import { ReactComponent as ArrowDropDownIcon } from "../../../assets/chevron_down.svg";
import { ReactComponent as ArrowDropUpIcon } from "../../../assets/chevron_up.svg";
import { Dialog, Typography, Grid, TextareaAutosize } from "@material-ui/core";
import DialogContent from "@material-ui/core/DialogContent";
import { ReactComponent as DeleteIcon } from "../../../assets/FollowUpDeleteIcon.svg";
import { useSelector, useDispatch } from "react-redux";
import {
  createLetterTemplate,
  updateLetterTemplate,
  getLetterTemplates,
  deleteLetterTemplate,
  getLetterContent,
  showAlert,
  saveLetterStorage
} from "../../../actions/radminUploads";
import Editor from "./Editor";
import { ReactComponent as CloseIcon } from "../../../assets/cancel-outline.svg";
import Flex from "../../../components/_styles/Flex";
import html2pdf from "html2pdf.js";
import { ReactComponent as RemoveRecoIcon } from "../../../assets/close-outline.svg";

import ReactQuill, { Quill } from "react-quill";
import RemoveConfirmation from "../Cohorts/RemoveConfirmation";
import moment from "moment";

import { saveAs } from 'file-saver';
import htmlDocx from 'html-docx-js/dist/html-docx';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  datePicker: {
    paddingLeft: 36,
  },
  dialogContent: {
    minWidth: 577,
    maxWidth: 800,
    maxHeight: 600,
    minHeight: 188,
  },
  leftTabHead: {
    paddingBottom: 10,
  },
  tabLabel: {
    cursor: "pointer",
    color: "#9FA2B4",
    textAlign: "center",
  },
  rightTabHead: {
    textAlign: "right",
    paddingBottom: 10,
  },
  tabBorderBottom: {
    borderBottom: "3px solid #4dabf5",
  },
  formControlDropdownMessage: {
    width: "95%",
  },
  formControlDropdownTemplate: {
    width: "95%",
    marginLeft: "5%",
  },
  selectInput: {
    padding: 10,
    fontSize: 16,
    "& .MuiOutlinedInput-input": {
      padding: 0,
    },
  },
  chooseMessageTypeSec: {
    display: "flex",
  },
  labelColor: {
    color: "#0C2945",
  },
  textField: {
    "& .MuiOutlinedInput-input": {
      fontSize: 14,
      padding: "10.5px 14px",
    },
  },
  centerSec: {
    height: "auto",
    maxHeight: 410,
    margin: "0 auto",
  },
  smsFromSec: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
  },
  smsToSec: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));

export const SmsContent = materialStyle(Typography)({
  color: "#3F4857",
  fontSize: 14,
  fontWeight: 600,
  padding: "10px 0",
});

const PersionalizedText = materialStyle(Typography)({
  color: "black",
  fontSize: 16,
  fontWeight: 400,
  padding: "8px 0",
  width: "100%",
  paddingLeft: 10,
});

const AddButton = styled.button`
  color: white;
  background-color: #00aeef;
  border: none;
  border-radius: 4px;
  padding: 0 12px;
  font-size: 15px;
  font-weight: 600;
  height: 38px;
  span {
    display: inline-block;
    transition: transform 0.3s ease-in-out;
  }

  &:hover {
    background-color: #06739D;
    border: none;
  }

  &:hover span {
    transform: scale(1.1);
  }
`;
const InputField = styled.input`
  height: 38px;
  width: 255px;
  font-size: 16px;
  border: 1px solid #d2d3d7;
  border-radius: 4px;
  padding-left: 12px;
  padding-right: 12px;
`;

const Button = styled.button`
  width: 172px;
  height: 38px;
  background-color: ${(props) => (props.bg ? props.bg : "#00AEEF")};
  border-radius: 4px;
  border: ${(props) => (props.border ? "2px solid #00AEEF" : 0)};
  font: bold 14px "Open Sans", sans-serif;
  text-align: center;
  color: ${(props) => (props.color ? props.color : "#ffffff")};
  display: block;
  cursor: ${(props) => (props.disabled ? "" : "pointer")};
  opacity: ${(props) => (props.disabled ? "0.3" : "1")};
   span {
    display: inline-block;
    transition: transform 0.3s ease-in-out;
  }

  &:hover {
    background-color: ${(props) => props.hoverBg || '#0088CC'};
    color: #ffffff !important;
    border: none;
  }

  &:hover span {
    font-weight: bold;
    transform: scale(1.1);
    color: #ffffff !important;
  }
`;

export const PersionalizedTextContainer = materialStyle(Grid)({
  border: "1px solid #CBCCCF",
  borderRadius: "4px",
});
const PersonalizedFieldSection = materialStyle(Grid)({
  display: "flex",
  alignItems: "center",
  width: "100%",
  gap: "21px",
  justifyContent: "flex-end",
  marginRight: "21px",
});

export const PersonalizedInnerContainer = materialStyle(Grid)({
  cursor: "pointer",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  height: 38,
});
const InsertPersonalizedSection = materialStyle(Grid)({
  backgroundColor: "#F5F5F5",
  height: "200px",
  overflowY: "auto",
  padding: "10px 0px",
});
const PersonalizedRow = materialStyle(Grid)({
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "8px",
});
const PeronalizedText = materialStyle(Typography)({
  fontSize: 14,
  fontWeight: 400,
  margin: 0,
  marginLeft: 10,
  color: "#8F8F8F",
});
export const ParagraphContainer = materialStyle(Grid)({
  padding: "5px 10px",
  cursor: "auto",
});
export const SmsInfoContainer = materialStyle(Grid)({
  padding: "0px 10px",
  display: "flex",
});

const BottomHeading = materialStyle(Typography)({
  fontSize: 19,
  padding: "8px 0 ",
  fontWeight: 700,
  color: "#252733",
  fontFamily: "Roboto Condensed",
});

const TemplateRowContainer = materialStyle(Grid)({
  display: "flex",
  alignItems: "center",
  margin: "0 auto",
  justifyContent: "space-between",
  padding: "10px",
});
const TemplateTitle = materialStyle(Typography)({
  fontSize: 16,
  color: "#000000",
});
const ButtonContainer = materialStyle(Grid)({
  cursor: "pointer",
  height: "35px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "6px 6px",
  color: (props) =>props.color ? props.color : "#ffffff",
  backgroundColor: (props) => props.isHover
    ? props.bg
      ? props.bg
      : "#00AEEF"
    : "transparent",
  width: (props) => props.width,
  borderRadius: 3,
  border: (props) => props.border ? "2px solid #00AEEF" : 0,
  "p": {
    display: (props) => props.isHover ?'inline-block' : '',
    transition: (props) => props.isHover ? "transform 0.3s ease-in-out" : "",
  },

  "&:hover": {
    backgroundColor: (props) =>props.hoverBg
      ? props.hoverBg
      : props.outlinedBr
      ? "#ffffff"
      : "#0088CC",
    border: (props) => props.isHover
      ? props.hoverBg
        ? props.outlinedBr
          ? `2px solid ${props.outlinedBr}`
          : "none"
        : "none"
      : "2px solid #00AEEF",
  },
  "&:hover p": {
    fontWeight: (props) => props.isHover ? "bold" : '',
    transform: (props) => props.isHover ? "scale(1.1)" : '',
  }
});

const OutlinedButton = styled.button`
  width: ${(props) => props.width || "120px"};
  height: ${(props) => props.height || "38px"};
  background: ${(props) => (props.disabled ? "#ffffff" : props.outlinedBr ? '#ffffff' : props.bg || "white")};
  color: ${(props) => (props.disabled ? "#00AEEF" : props.color || "#00AEEF")};
  border: ${(props) => (props.disabled ? "2px solid #00AEEF" : '2px solid #00AEEF')};
  border-radius: 5px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 20px;
  cursor: ${(props) => (props.templates && props.templates.length >= props.totalTemplates ? "not-allowed" : "pointer")};
  transition: background-color 0.3s ease-in-out, transform 0.2s ease-in-out;

  &:hover {
    color: ${(props) => (props.disabled ? "#a0a0a0" : props.outlinedBr ? "#06739D" :"#ffffff")};
    transform: ${(props) => (props.disabled ? "none" : "scale(1.05)")};
    border: ${(props) => (props.disabled ? "2px solid #00AEEF" : `2px solid #06739D`)}
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  }

  span {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    font-family: "Roboto Condensed", sans-serif;
    transition: transform 0.3s ease-in-out, color 0.3s ease-in-out;
  }
  span p {
  display: flex;
    align-items: center;
    margin: auto;
  }

  &:hover span {
    transform: ${(props) => (props.disabled ? "none" : "scale(1.1)")};
    color: ${(props) => (props.disabled ? "#00AEEF" : props.outlinedBr ? "#06739D" :"#ffffff")};
  }
  img {
    transition: filter 0.3s ease-in-out;
  }
`;
const BorderWraper = materialStyle(Grid)({
  border: "1px solid #BFBFBF",
  background: "#F6F6F6",
  marginBottom: "10px",
  borderRadius: "5px",
});

const BottomContainer = materialStyle(Grid)({
  margin: "0 auto",
});

const Text = materialStyle(Typography)({
  color: (props) => props.textcolor,
  fontSize: 14,
  fontWeight: 600,
  fontFamily: "Roboto Condensed",
});

const CenterSecContainer = materialStyle(Grid)({
  height: 298,
});

const PreviewButtonContainer = materialStyle(Grid)({
  display: "flex",
  justifyContent: "flex-end",
  color: '#00AEEF',
  marginBottom: "28px",
  'p': {
    
    transition: 'transform 0.3s ease-in-out',
  },

  '&:hover p': {
    color: '#06739D',
    fontWeight: 'bold',
    transform: 'scale(1.1)'
  }
});

const CustomButton = materialStyle(Grid)({
  backgroundColor: (prop) => prop.bg,
  display: "flex",
  fontFamily: "Open Sans",
  width: (prop) => (prop.width ? prop.width : 135),
  justifyContent: "center",
  alignItems: "center",
  color: "white",
  fontSize: 14,
  fontWeight: 600,
  borderRadius: 4,
  height: "38px",
  padding: "0 10px",
  opacity: (props)=>(props.disabled? 0.5 : 1),
  cursor: (props) => (props.disabled ? "default" : "pointer"),
  'span': {
    display: 'inline-block',
    transition: 'transform 0.3s ease-in-out',
  },

  '&:hover': {
    backgroundColor: (props) => props.hoverBg || '#0088CC',
    border: 'none'
  },
  
  '&:hover span': {
    fontWeight: 'bold',
    transform: 'scale(1.1)',
    color:'#ffffff !important'
  }
});

export const CreateTemplateContainer = materialStyle(Grid)({
  maxHeight: "290px",
});

const TemplateBtnContainer = materialStyle(Grid)({
  display: "flex",
  gap: "15px",
});

export default function LetterTemplateModal({
  openMessage,
  openMessageHandler,
  patientDetails,
  currentNode,
  selectedIds,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const templateIdToPreview = useSelector(
    (state) => state.radAdmin.letterTemplates?.templateIdToPreview
  );
  const templateToPreview = useSelector(
    (state) => state.radAdmin.letterTemplates?.templateToPreview
  );

  const totalTemplates = useSelector(
    (state) => state.radAdmin.letterTemplates?.totalItems
  );
  const permission = useSelector((state) => state.auth.user.permission_level);
  const rolePermissions = useSelector(
    (state) =>state.auth.user.permissions
  );
  const addPermission = rolePermissions?.find(itm=>itm.name ==="Follow-Ups")?.permissions.find(itm=>itm.codename === "add_follow-ups")?.is_authorized
  const updatePermission = rolePermissions?.find(itm=>itm.name ==="Follow-Ups")?.permissions.find(itm=>itm.codename === "change_follow-ups")?.is_authorized


  const [selectedTab, setTab] = useState("1");
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [sendTo, setSendTo] = useState("-");
  const [templateTitle, setTemplateTitle] = useState(currentNode?.title || "");
  const [templateContent, setTemplateContent] = useState(
    currentNode?.letter_content || ""
  );
  const quillRef = useRef();

  const [populatedContent, setPopulatedContent] = useState([]);

  const [templatePageNo, setTemplatePageNo] = useState(1);
  const [isClickedPersionalized, setIsClickedPersionalized] = useState(false);
  const [isSaveTemplateClicked, setIsSaveTemplateClicked] = useState(false);
  const [defaultValue, setDefaultValue] = useState({
    patientMRN: "",
    referringPhysicianFirstName: "",
    referringPhysicianLastName: "",
    patientFirstName: "",
    patientLastName: "",
    patientPhoneNumber: "",
    patientPhoneNumberType: "",
    patientLanguagePreference: "",
    patientAddress: "",
    patientAge: "",
    patientEmail: "",
    referringPhysicianEmail: "",
    referringPhysicianUniqueId: "",
    referringPhysicianFax: "",
    referringPhysicianPhoneNumber: "",
    reportModality:"",
    reportExamDate: "", 
    reportRadiologistFirstName: "",  
    reportRadiologistLastName: "",
    recommendationModality: "",
    recommendationAnatomy: "",
    recommendationRangeStart:  "",
    recommendationRangeEnd: "",
  });

  useEffect(() => {
    dispatch(getLetterTemplates(templatePageNo));
  }, []);

  useEffect(() => {
    if (!isNull(selectedTemplate)) {
      setTemplateTitle(selectedTemplate.letter_name);
      setTemplateContent(selectedTemplate.letter_content);
      dispatch(
        getLetterContent(
          selectedTemplate.id,
          selectedIds.length > 0 ? selectedIds : [patientDetails.id]
        )
      ).then((res) => {
        if (res) {
          setPopulatedContent(res);
        }
      });
    }
  }, [selectedTemplate]);

  useEffect(() => {
    if (templateToPreview) {
      setTemplateContent(templateToPreview);
    }
  }, [templateToPreview]);
  useEffect(() => {
    if (patientDetails?.patient?.phone_number) {
      setSendTo(patientDetails.patient.phone_number);
    }
  }, [patientDetails]);

  const createTemplateHandler = () => {
    window.analytics.track("Save-As-Template-Button-Click");
    if (isEmpty(templateTitle)) {
      alert("Please enter title for template");
      return;
    }
    if (isEmpty(templateContent)) {
      alert("Please enter content for template");
      return;
    }
    setIsSaveTemplateClicked(true);
    let dataForTemplate = {
      letter_name: templateTitle,
      letter_personalized_content: {},
      letter_content: templateContent,
    };

    if (defaultValue.patientMRN) {
      dataForTemplate.letter_personalized_content.patient_mrn =
        defaultValue.patientMRN;
    }
    if (defaultValue.referringPhysicianFirstName) {
      dataForTemplate.letter_personalized_content.referring_physician_first_name =
        defaultValue.referringPhysicianFirstName;
    }
    if (defaultValue.referringPhysicianLastName) {
      dataForTemplate.letter_personalized_content.referring_physician_last_name =
        defaultValue.referringPhysicianLastName;
    }

    if (defaultValue.patientFirstName) {
      dataForTemplate.letter_personalized_content.first_name =
        defaultValue.patientFirstName;
    }
    if (defaultValue.patientLastName) {
      dataForTemplate.letter_personalized_content.last_name =
        defaultValue.patientLastName;
    }
    if (defaultValue.patientPhoneNumber) {
      dataForTemplate.letter_personalized_content.patient_phone_number =
        defaultValue.patientPhoneNumber;
    }

    if (defaultValue.patientPhoneNumberType) {
      dataForTemplate.letter_personalized_content.patient_phone_number_type =
        defaultValue.patientPhoneNumberType;
    }
    if (defaultValue.patientLanguagePreference) {
      dataForTemplate.letter_personalized_content.patient_language_preference =
        defaultValue.patientLanguagePreference;
    }

    if (defaultValue.patientAddress) {
      dataForTemplate.letter_personalized_content.patient_address =
        defaultValue.patientAddress;
    }

    if (defaultValue.patientAge) {
      dataForTemplate.letter_personalized_content.patient_age =
        defaultValue.patientAge;
    }
    if (defaultValue.patientEmail) {
      dataForTemplate.letter_personalized_content.patient_email =
        defaultValue.patientEmail;
    }

    if (defaultValue.referringPhysicianEmail) {
      dataForTemplate.letter_personalized_content.referring_physician_email =
        defaultValue.referringPhysicianEmail;
    }

    if (defaultValue.referringPhysicianUniqueId) {
      dataForTemplate.letter_personalized_content.referring_physician_unique_id =
        defaultValue.referringPhysicianUniqueId;
    }

    if (defaultValue.referringPhysicianFax) {
      dataForTemplate.letter_personalized_content.referring_physician_fax =
        defaultValue.referringPhysicianFax;
    }
    if (defaultValue.referringPhysicianPhoneNumber) {
      dataForTemplate.letter_personalized_content.referring_physician_phone_number =
        defaultValue.referringPhysicianPhoneNumber;
    }
    if (defaultValue.reportModality) {
      dataForTemplate.letter_personalized_content.report_modality =
        defaultValue.reportModality;
    }
    if (defaultValue.reportExamDate) {
      dataForTemplate.letter_personalized_content.report_exam_date =
        defaultValue.reportExamDate;
    }
    if (defaultValue.reportRadiologistFirstName) {
      dataForTemplate.letter_personalized_content.report_radiologist_first_name =
        defaultValue.reportRadiologistFirstName;
    }
    if (defaultValue.reportRadiologistLastName) {
      dataForTemplate.letter_personalized_content.report_radiologist_last_name =
        defaultValue.reportRadiologistLastName;
    }
    if (defaultValue.recommendationModality) {
      dataForTemplate.letter_personalized_content.recommendation_modality =
        defaultValue.recommendationModality;
    }
    if (defaultValue.recommendationAnatomy) {
      dataForTemplate.letter_personalized_content.recommendation_anatomy =
        defaultValue.recommendationAnatomy;
    }
    if (defaultValue.recommendationRangeStart) {
      dataForTemplate.letter_personalized_content.recommendation_range_start =
        defaultValue.recommendationRangeStart;
    }
    if (defaultValue.recommendationRangeEnd) {
      dataForTemplate.letter_personalized_content.recommendation_range_end =
        defaultValue.recommendationRangeEnd;
    }

    dispatch(createLetterTemplate(dataForTemplate)).then((data) => {
      setIsSaveTemplateClicked(false);
      if (data?.response) {
        setSelectedTemplate(data?.response);
      }
    });
  };

  const updateTemplateHandler = () => {
    if (isSaveTemplateClicked) {
      return;
    }
    window.analytics.track("Edit-Template-Button-Click");

    setIsSaveTemplateClicked(true);
    let dataForTemplate = {
      letter_content: templateContent,
      letter_personalized_content: {},
    };

    if (defaultValue.patientMRN) {
      dataForTemplate.letter_personalized_content.patient_mrn =
        defaultValue.patientMRN;
    }
    if (defaultValue.referringPhysicianFirstName) {
      dataForTemplate.letter_personalized_content.referring_physician_first_name =
        defaultValue.referringPhysicianFirstName;
    }
    if (defaultValue.referringPhysicianLastName) {
      dataForTemplate.letter_personalized_content.referring_physician_last_name =
        defaultValue.referringPhysicianLastName;
    }

    if (defaultValue.patientFirstName) {
      dataForTemplate.letter_personalized_content.first_name =
        defaultValue.patientFirstName;
    }
    if (defaultValue.patientLastName) {
      dataForTemplate.letter_personalized_content.last_name =
        defaultValue.patientLastName;
    }
    if (defaultValue.patientPhoneNumber) {
      dataForTemplate.letter_personalized_content.patient_phone_number =
        defaultValue.patientPhoneNumber;
    }

    if (defaultValue.patientPhoneNumberType) {
      dataForTemplate.letter_personalized_content.patient_phone_number_type =
        defaultValue.patientPhoneNumberType;
    }
    if (defaultValue.patientLanguagePreference) {
      dataForTemplate.letter_personalized_content.patient_language_preference =
        defaultValue.patientLanguagePreference;
    }

    if (defaultValue.patientAddress) {
      dataForTemplate.letter_personalized_content.patient_address =
        defaultValue.patientAddress;
    }

    if (defaultValue.patientAge) {
      dataForTemplate.letter_personalized_content.patient_age =
        defaultValue.patientAge;
    }
    if (defaultValue.patientEmail) {
      dataForTemplate.letter_personalized_content.patient_email =
        defaultValue.patientEmail;
    }

    if (defaultValue.referringPhysicianEmail) {
      dataForTemplate.letter_personalized_content.referring_physician_email =
        defaultValue.referringPhysicianEmail;
    }

    if (defaultValue.referringPhysicianUniqueId) {
      dataForTemplate.letter_personalized_content.referring_physician_unique_id =
        defaultValue.referringPhysicianUniqueId;
    }

    if (defaultValue.referringPhysicianFax) {
      dataForTemplate.letter_personalized_content.referring_physician_fax =
        defaultValue.referringPhysicianFax;
    }
    if (defaultValue.referringPhysicianPhoneNumber) {
      dataForTemplate.letter_personalized_content.referring_physician_phone_number =
        defaultValue.referringPhysicianPhoneNumber;
    }
    if (defaultValue.reportModality) {
      dataForTemplate.letter_personalized_content.report_modality =
        defaultValue.reportModality;
    }
    if (defaultValue.reportExamDate) {
      dataForTemplate.letter_personalized_content.report_exam_date =
        defaultValue.reportExamDate;
    }
    if (defaultValue.reportRadiologistFirstName) {
      dataForTemplate.letter_personalized_content.report_radiologist_first_name =
        defaultValue.reportRadiologistFirstName;
    }
    if (defaultValue.reportRadiologistLastName) {
      dataForTemplate.letter_personalized_content.report_radiologist_last_name =
        defaultValue.reportRadiologistLastName;
    }
    if (defaultValue.recommendationModality) {
      dataForTemplate.letter_personalized_content.recommendation_modality =
        defaultValue.recommendationModality;
    }
    if (defaultValue.recommendationAnatomy) {
      dataForTemplate.letter_personalized_content.recommendation_anatomy =
        defaultValue.recommendationAnatomy;
    }
    if (defaultValue.recommendationRangeStart) {
      dataForTemplate.letter_personalized_content.recommendation_range_start =
        defaultValue.recommendationRangeStart;
    }
    if (defaultValue.recommendationRangeEnd) {
      dataForTemplate.letter_personalized_content.recommendation_range_end =
        defaultValue.recommendationRangeEnd;
    }

    setPopulatedContent([]);
    dispatch(updateLetterTemplate(dataForTemplate, selectedTemplate.id)).then(
      () => {
        setIsSaveTemplateClicked(false);
        dispatch(
          getLetterContent(
            selectedTemplate.id,
            selectedIds.length > 0 ? selectedIds : [patientDetails.id]
          )
        ).then((res) => {
          if (res) {
            setPopulatedContent(res);
          }
        });
      }
    );
  };

  const updateTemplatePageNum = (value) => {
    setTemplatePageNo(value);
  };

  const onCloseDialogHandler = () => {
    openMessageHandler(false);
    setTemplateContent("");
    setTemplateTitle("");
    setTab("1");
    setSendTo("-");
    setSelectedTemplate(null);
    setIsClickedPersionalized(false);
    setDefaultValue({
      ...defaultValue,
      patientMRN: "",
      referringPhysicianFirstName: "",
      referringPhysicianLastName: "",
      patientFirstName: "",
      patientLastName: "",
      patientPhoneNumber: "",
      patientPhoneNumberType: "",
      patientLanguagePreference: "",
      patientAddress: "",
      patientAge: "",
      patientEmail: "",
      referringPhysicianEmail: "",
      referringPhysicianUniqueId: "",
      referringPhysicianFax: "",
      referringPhysicianPhoneNumber: "",
      report_modality: "",
      report_exam_date:"",
      report_radiologist_first_name : "",
      report_radiologist_last_name : "",
      recommendation_modality : "",
      recommendation_anatomy : "",
      recommendation_range_start : "",
      recommendation_range_end : ""
    });
  };

  const personalizedClickHandler = () => {
    setIsClickedPersionalized(!isClickedPersionalized);
  };
  const handleChange = (e) => {
    let { name, value } = e.target;
    setDefaultValue({ ...defaultValue, [name]: value });
  };
  const checkforTemplatedContent = (value, key) => {
    let content = templateContent;
    let valueToSearch = `${key} | default`;
  
    let requiredIndex = content.indexOf(valueToSearch);
  
    if (requiredIndex === -1) {
      let concatedValue = content + `{{${key} | default("${value}")}}`;
      setTemplateContent(concatedValue);
    } else {
      let replacedValue = content.replace(
        new RegExp(`${key} \\| default\\("[^"]*"\\)`),
        `${key} | default("${value}")`
      );
      setTemplateContent(replacedValue);
    }
    setIsClickedPersionalized(false);
  };
  

  const addDefaultHandler = (from) => {
    if (from === "row1") {
      checkforTemplatedContent(defaultValue.patientMRN, "patient_mrn");
    } else if (from === "row2") {
      checkforTemplatedContent(defaultValue.patientFirstName, "first_name");
    } else if (from === "row3") {
      checkforTemplatedContent(defaultValue.patientLastName, "last_name");
    } else if (from === "row4") {
      checkforTemplatedContent(
        defaultValue.patientPhoneNumber,
        "patient_phone_number"
      );
    } else if (from === "row5") {
      checkforTemplatedContent(
        defaultValue.patientPhoneNumberType,
        "patient_phone_number_type"
      );
    } else if (from === "row6") {
      checkforTemplatedContent(
        defaultValue.patientLanguagePreference,
        "patient_language_preference"
      );
    } else if (from === "row7") {
      checkforTemplatedContent(defaultValue.patientAddress, "patient_address");
    } else if (from === "row8") {
      checkforTemplatedContent(defaultValue.patientAge, "patient_age");
    } else if (from === "row9") {
      checkforTemplatedContent(defaultValue.patientEmail, "patient_email");
    } else if (from === "row10") {
      checkforTemplatedContent(
        defaultValue.referringPhysicianFirstName,
        "referring_physician_first_name"
      );
    } else if (from === "row11") {
      checkforTemplatedContent(
        defaultValue.referringPhysicianLastName,
        "referring_physician_last_name"
      );
    } else if (from === "row12") {
      checkforTemplatedContent(
        defaultValue.referringPhysicianEmail,
        "referring_physician_email"
      );
    } else if (from === "row13") {
      checkforTemplatedContent(
        defaultValue.referringPhysicianUniqueId,
        "referring_physician_unique_id"
      );
    } else if (from === "row14") {
      checkforTemplatedContent(
        defaultValue.referringPhysicianFax,
        "referring_physician_fax"
      );
    } else if (from === "row15") {
      checkforTemplatedContent(
        defaultValue.referringPhysicianPhoneNumber,
        "referring_physician_phone_number"
      );
    }
    else if (from === "row16") {
      checkforTemplatedContent(
        defaultValue.reportModality,
        "report_modality"
      );
    }
    else if (from === "row17") {
      checkforTemplatedContent(
        defaultValue.reportExamDate,
        "report_exam_date"
      );
    }
    else if (from === "row18") {
      checkforTemplatedContent(
        defaultValue.reportRadiologistFirstName,
        "report_radiologist_first_name"
      );
    }else if (from === "row19") {
      checkforTemplatedContent(
        defaultValue.reportRadiologistLastName,
        "report_radiologist_last_name"
      );
    }else if (from === "row20") {
      checkforTemplatedContent(
        defaultValue.recommendationModality,
        "recommendation_modality"
      );
    }else if (from === "row21") {
      checkforTemplatedContent(
        defaultValue.recommendationAnatomy,
        "recommendation_anatomy"
      );
    }else if (from === "row22") {
      checkforTemplatedContent(
        defaultValue.recommendationRangeStart,
        "recommendation_range_start"
      );
    }else if (from === "row23") {
      checkforTemplatedContent(
        defaultValue.recommendationRangeEnd,
        "recommendation_range_end"
      );
    }
  };
  const pdfRef = useRef();
  const generatePDF = () => {
    function getValuesForDynamicIds(dataArray) {
      const values = [];
      dataArray.forEach((obj) => {
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            values.push(obj[key]);
          }
        }
      });
      return values;
    }

    const values = getValuesForDynamicIds(populatedContent);
    dispatch(saveLetterStorage({
      patient: patientDetails.patient.id,
      content: values.map(itm=>itm).join('')
    }));
    const htmlFromContent = values
      ?.map((itm) => '<div style="min-height:600px;">' + itm + "</div>")
      ?.join('<div class="beforeClass"/>');

    html2pdf()
      .set({
        jsPDF: {
          format: "a4",
        },
        pagebreak: { before: ".beforeClass" ,  mode: 'avoid-all'},
        html2canvas: { useCORS: true, scale: 1 },
        margin:15
      })
      .from(htmlFromContent)
      .save(selectedTemplate?.letter_name);
  };


  const generateWordDoc = () => {
    function getValuesForDynamicIds(dataArray) {
      const values = [];
      dataArray.forEach((obj) => {
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            values.push(obj[key]);
          }
        }
      });
      return values;
    }
  
    const values = getValuesForDynamicIds(populatedContent);
    dispatch(saveLetterStorage({
      patient: patientDetails.patient.id,
      content: values.map(itm=>itm).join('')
    }));
    const htmlFromContent = values
      ?.map((itm) => '<div style="min-height:600px;">' + itm + "</div>")
      ?.join('<div class="beforeClass"/>');

  
     const converted = htmlDocx.asBlob(htmlFromContent, {
      orientation: 'portrait',
      margins: { top: 720, right: 720, bottom: 720, left: 720 }
  });;
    saveAs(converted, selectedTemplate?.letter_name + '.docx');


  };


  const debouncedGeneratePDF = useCallback(
    debounce(generatePDF, 1000, { leading: true, trailing: false }),
    [populatedContent]
  );

  const debouncedGenerateWord = useCallback(
    debounce(generateWordDoc, 1000, { leading: true, trailing: false }),
    [populatedContent]
  );


  return (
    <div>
      <Dialog
        open={openMessage}
        aria-labelledby="form-dialog-title"
        maxWidth="lg"
        style={{
          backdropFilter: "blur(5px)",
        }}
        onClose={() => onCloseDialogHandler()}
      >
        <DialogContent
          style={{
            width:
              selectedTab === "3"
                ? "820px"
                : selectedTab === "2"
                ? "597px"
                : "initial",
            height: selectedTab === "2" ? "547px" : "initial",
            paddingTop: "30px",
          }}
          className={classes.dialogContent}
        >
          {selectedTab === "2" && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "26px",
              }}
            >
              <h2
                style={{
                  color: "#0C2945",
                  fontSize: "28px",
                  fontWeight: 700,
                  fontFamily: "Roboto Condensed",
                  marginBottom: 0,
                }}
              >
                Saved Templates
              </h2>
              <CloseIcon
                style={{ cursor: "pointer" }}
                onClick={() => openMessageHandler(false)}
              />
            </div>
          )}
          {selectedTab === "3" && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h2
                style={{
                  color: "#0C2945",
                  fontSize: "28px",
                  fontWeight: 700,
                  fontFamily: "Roboto Condensed",
                  marginBottom: 0,
                }}
              >
                {selectedTemplate ? "Print Letter" : "Create New Template"}
              </h2>
              <CloseIcon
                style={{ cursor: "pointer" }}
                onClick={() => openMessageHandler(false)}
              />
            </div>
          )}

          {selectedTab === "3" && !selectedTemplate && (
            <>
              <h4
                style={{
                  fontFamily: "Roboto Condensed",
                  fontSize: "14px",
                  fontWeight: 700,
                  color: "#6D6E6E",
                  marginTop: "35px",
                }}
              >
                TEMPLATE TITLE
              </h4>
              <TextField
                id="outlined-uncontrolled"
                variant="outlined"
                className={classes.textField}
                value={templateTitle}
                onChange={(e) => setTemplateTitle(e.target.value)}
                fullWidth={true}
                placeholder="Create title"
              />
            </>
          )}
          {selectedTab === "3" && (
            <>
              <>
                <h4
                  style={{
                    fontFamily: "Roboto Condensed",
                    fontSize: "14px",
                    fontWeight: 700,
                    color: "#6D6E6E",
                    marginTop: "30px",
                  }}
                >
                  PERSONALIZED CONTENT
                </h4>
                <CreateTemplate
                  isClickedPersionalized={isClickedPersionalized}
                  personalizedClickHandler={personalizedClickHandler}
                  defaultValue={defaultValue}
                  handleChange={handleChange}
                  addDefaultHandler={addDefaultHandler}
                  quillRef={quillRef}
                  setDefaultValue={setDefaultValue}
                />
              </>

              <h4
                style={{
                  fontFamily: "Roboto Condensed",
                  fontSize: "14px",
                  fontWeight: 700,
                  color: "#6D6E6E",
                  marginTop: "30px",
                }}
              >
                LETTER CONTENT
              </h4>

              <Editor
                templateContent={templateContent}
                setTemplateContent={setTemplateContent}
                placeholder={"This is placeholder text - Change me!"}
                disableImage={false}
                quillRef={quillRef}
                customImageUpload={false}
              />
            </>
          )}
          {selectedTab === "1" ? (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "47px",
                  alignItems: "center",
                }}
              >
                <h2
                  style={{
                    fontSize: "28px",
                    fontWeight: 700,
                    color: "#0C2945",
                    marginBottom: "0px",
                    fontFamily: "Roboto Condensed",
                  }}
                >
                  Print Letter
                </h2>
                <CloseIcon
                  style={{ cursor: "pointer" }}
                  onClick={() => openMessageHandler(false)}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  justifyContent: "center",
                }}
              >
                <Button hoverBg={"#06739D"} onClick={() => setTab("2")}><span>Saved Templates</span></Button>
                <Button
                  bg="white"
                  color="#00AEEF"
                  border
                  brColor="#ffffff"
                  onClick={() => {
                    if((permission && addPermission) || !permission){
                      setTab("3");
                    }else{
                      dispatch(
                        showAlert('danger', 'Error', `You don't have permission to create letter template`)
                      );
                    }                  
                  }}
                >
                  <span>Create New Template</span>
                </Button>
              </div>
            </>
          ) : (
            <>
              {selectedTab === "2" && (
                <CenterSecContainer>
                  <Grid className={classes.centerSec}>
                    {selectedTab === "2" ? (
                      <>
                        <SaveTemplateSec
                          setSelectedTemplate={setSelectedTemplate}
                          setIsSecondTab={setTab}
                          totalTemplates={totalTemplates}
                          templatePageNo={templatePageNo}
                          setTemplatePageNo={updateTemplatePageNum}
                          setDefaultValue={setDefaultValue}
                        />
                      </>
                    ) : null}
                  </Grid>
                </CenterSecContainer>
              )}

              {selectedTab === "3" && (
                <BottomContainer>
                  <PreviewButtonContainer>
                    {selectedTemplate ? (
                      <p
                        onClick={()=>{
                          if((permission && updatePermission) || !permission){
                            updateTemplateHandler()
                          }else{
                            dispatch(
                              showAlert('danger', 'Error', `You don't have permission to update letter template`)
                            );
                          }                  
                        }}
                        style={{
                          fontWeight: 600,
                          fontSize: "14px",
                          cursor: isSaveTemplateClicked
                            ? "not-allowed"
                            : "pointer",
                          marginTop: "5px",
                        }}
                      >
                        Save Changes to Template
                      </p>
                    ) : (
                      <CustomButton
                        bg="#00AEEF"
                        width="104px"
                        onClick={createTemplateHandler}
                        style={{ marginTop: "30px" }}
                        hoverBg={"#06739D"}
                      >
                        {isSaveTemplateClicked ? (
                          <Spinner animation="border" role="status" size="sm" />
                        ) : (
                          <span>Save</span>
                        )}
                      </CustomButton>
                    )}
                  </PreviewButtonContainer>
                  {selectedTemplate && (
                    <div style={{ marginBottom: "30px" }}>
                      <BottomHeading>Preview </BottomHeading>
                      <div style={{display:'flex', gap:'10px'}}>
                      <CustomButton
                        onClick={() => {
                          if (populatedContent.length > 0) {
                            debouncedGeneratePDF();
                          }
                        }}
                        width="224px"
                        bg="#00AEEF"
                        disabled={populatedContent.length ===0}
                      >
                        <span>Download and View as PDF</span>
                      </CustomButton>
                      <CustomButton
                        onClick={() => {
                          if (populatedContent.length > 0) {
                            debouncedGenerateWord();
                          }
                        }}
                        width="224px"
                        bg="#00AEEF"
                        disabled={populatedContent.length ===0}
                      >
                        <span>Download and View as Doc</span> 
                      </CustomButton>
                      </div>
                    
                      <div ref={pdfRef} />
                    </div>
                  )}
                </BottomContainer>
              )}
            </>
          )}
          {selectedTemplate && selectedTab === "3" && (
            <BottomContainer></BottomContainer>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}

const SaveTemplateSec = ({
  setSelectedTemplate,
  setIsSecondTab,
  totalTemplates,
  templatePageNo,
  setTemplatePageNo,
  setDefaultValue,
}) => {
  const dispatch = useDispatch();
  const templates = useSelector((state) => state.radAdmin.letterTemplates.data);
  const isLoading = useSelector(
    (state) => state.radAdmin.letterTemplates.isLoading
  );
  const permission = useSelector((state) => state.auth.user.permission_level);
  const rolePermissions = useSelector(
    (state) =>state.auth.user.permissions
  );
  const deletePermission = rolePermissions?.find(itm=>itm.name ==="Follow-Ups")?.permissions.find(itm=>itm.codename === "delete_follow-ups")?.is_authorized



  const onLoadMore = () => {
    dispatch(getLetterTemplates(templatePageNo + 1));
    setTemplatePageNo(templatePageNo + 1);
  };

  const [removeDialogOpen, setRemoveDialogOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [isLoadingDeleteTemplate, setIsLoadingDeleteTemplate] = useState(false)


  
  const dialogHandler = (id) => {
    setRemoveDialogOpen(!removeDialogOpen);
    setSelectedId(id);
    window.analytics.track("Delete-Template-Button-Click");
  }

const deleteTemplateHandler = () => {
  setIsLoadingDeleteTemplate(true)
   dispatch(deleteLetterTemplate(selectedId))
  .then(() => {
      setIsLoadingDeleteTemplate(false)
      setRemoveDialogOpen(false);
      setSelectedId()
  })
}


  const onSelectTemplate = (template) => {
    setSelectedTemplate(template);
    setDefaultValue({
      patientMRN: template?.letter_personalized_content?.patient_mrn || "",
      referringPhysicianFirstName:
        template?.letter_personalized_content?.referring_physician_first_name ||
        "",
      referringPhysicianLastName:
        template?.letter_personalized_content?.referring_physician_last_name ||
        "",
      patientFirstName: template?.letter_personalized_content?.first_name || "",
      patientLastName: template?.letter_personalized_content?.last_name || "",
      patientPhoneNumber:
        template?.letter_personalized_content?.patient_phone_number || "",
      patientPhoneNumberType:
        template?.letter_personalized_content?.patient_phone_number_type || "",
      patientLanguagePreference:
        template?.letter_personalized_content?.patient_language_preference ||
        "",
      patientAddress:
        template?.letter_personalized_content?.patient_address || "",
      patientAge: template?.letter_personalized_content?.patient_age || "",
      patientEmail: template?.letter_personalized_content?.patient_email || "",
      referringPhysicianEmail:
        template?.letter_personalized_content?.referring_physician_email || "",
      referringPhysicianUniqueId:
        template?.letter_personalized_content?.referring_physician_unique_id ||
        "",
      referringPhysicianFax:
        template?.letter_personalized_content?.referring_physician_fax || "",
      referringPhysicianPhoneNumber:
        template?.letter_personalized_content
          ?.referring_physician_phone_number || "",
      reportModality:
          template?.letter_personalized_content
            ?.report_modality || "",
      reportExamDate:
            template?.letter_personalized_content
              ?.report_exam_date || "", 
      reportRadiologistFirstName:
              template?.letter_personalized_content
                ?.report_radiologist_first_name || "",  
      reportRadiologistLastName: template?.letter_personalized_content?.report_radiologist_last_name || "",
      recommendationModality: template?.letter_personalized_content?.recommendation_modality || "",
      recommendationAnatomy: template?.letter_personalized_content?.recommendation_anatomy || "",
      recommendationRangeStart: template?.letter_personalized_content?.recommendation_range_start || "",
      recommendationRangeEnd: template?.letter_personalized_content?.recommendation_range_end || "",               
    });
    setIsSecondTab("3");
    window.analytics.track("Use-Template-Button-Click");
  };

  return (
    <>
      { isLoading?
      <div style={{ display: "flex", justifyContent: "center" , alignItems:'center', height:'300px'}}>
       <Spinner role="status" animation="border" size="sm" />
      </div>
      :  templates &&
        templates.map((t, i) => {
          return (
            <BorderWraper key={i}>
              <TemplateRowContainer>
                <Grid style={{ width: "70%" }}>
                  <TemplateTitle>{t.letter_name}</TemplateTitle>
                </Grid>
                <TemplateBtnContainer>
                  <TemplateButton
                                        hoverBg={"#06739D"}
                                        color={"#ffffff"}
                                        isHover={true}
                                        title='Select'
                                        clickHandler={() => onSelectTemplate(t)}
                                        style={{ width: "82px" }}
                                        textStyles={{ color: "white" }}
                  ></TemplateButton>
                  <DeleteIcon
                    style={{
                      color: "rgb(241, 43, 44)",
                      fontSize: 21,
                      cursor: "pointer",
                    }}
                    onClick={() =>{
                      if((permission && deletePermission) || !permission){
                        dialogHandler(t.id)
                      }else{
                        dispatch(
                          showAlert('danger', 'Error', `You don't have permission to delete letter template`)
                        );
                      }                          
                    }}
                  />
                </TemplateBtnContainer>
              </TemplateRowContainer>
            </BorderWraper>
          );
        })}

      
      { !isLoading && <div style={{ display: "flex", justifyContent: "center" }}>
        <OutlinedButton
          disabled={templates && templates.length >= totalTemplates}
          onClick={onLoadMore}
          outlinedBr={'#00AEEF'}
          templates
          totalTemplates
        >
          <span
          >
            {isLoading ? (
              <p>Loading...</p>
            ) : (
              <>
                Load More
                <img src={loadMoreIcon} />
              </>
            )}
          </span>
        </OutlinedButton>
      </div>
      }
      <RemoveConfirmation 
                content="Are you sure you want to remove this template?"
                openDialog={removeDialogOpen}
                dialogHandler={dialogHandler}
                isLoading={isLoadingDeleteTemplate}
                deleteHandler={deleteTemplateHandler}
                heading={'Remove Template'}
                removeHeader={'Yes, Remove Template'}
            />
    </>
  );
};

const CreateTemplate = ({
  isClickedPersionalized,
  personalizedClickHandler,
  defaultValue,
  handleChange,
  addDefaultHandler,
  quillRef,
  setDefaultValue,
}) => {

  return (
    <>
      <CreateTemplateContainer>
        <PersionalizedTextContainer>
          <PersonalizedInnerContainer
            isClicked={isClickedPersionalized}
            onClick={personalizedClickHandler}
          >
            <PeronalizedText>Select...</PeronalizedText>
            {isClickedPersionalized ? (
              <ArrowDropUpIcon style={{ cursor: "pointer", marginRight: 10 }} />
            ) : (
              <ArrowDropDownIcon
                style={{ cursor: "pointer", marginRight: 10 }}
              />
            )}
          </PersonalizedInnerContainer>
        </PersionalizedTextContainer>

        {isClickedPersionalized ? (
          <InsertPersonalizedSection>
            <PersonalizedRow noBorder>
              <BottomContainer>
                <PersionalizedText>{"{{patient_mrn}}"}</PersionalizedText>
              </BottomContainer>
              <PersonalizedFieldSection>
                <InputField
                  type="text"
                  name="patientMRN"
                  value={defaultValue.patientMRN}
                  onChange={(e) => handleChange(e)}
                  placeholder="Please add a default"
                />
                <AddButton
                  onClick={() =>
                    isEmpty(defaultValue.patientMRN)
                      ? alert("Value required!")
                      : addDefaultHandler("row1")
                  }
                >
                  <span>Add</span>
                </AddButton>
              </PersonalizedFieldSection>
            </PersonalizedRow>

            <PersonalizedRow>
              <BottomContainer>
                <PersionalizedText>{"{{first_name}}"}</PersionalizedText>
              </BottomContainer>
              <PersonalizedFieldSection>
                <InputField
                  type="text"
                  name="patientFirstName"
                  value={defaultValue.patientFirstName}
                  onChange={(e) => handleChange(e)}
                  placeholder="Please add a default"
                />
                <AddButton
                  onClick={() =>
                    isEmpty(defaultValue.patientFirstName)
                      ? alert("Value required!")
                      : addDefaultHandler("row2")
                  }
                >
                  <span>Add</span>
                </AddButton>
              </PersonalizedFieldSection>
            </PersonalizedRow>
            <PersonalizedRow>
              <BottomContainer>
                <PersionalizedText>{"{{last_name}}"}</PersionalizedText>
              </BottomContainer>
              <PersonalizedFieldSection>
                <InputField
                  type="text"
                  name="patientLastName"
                  value={defaultValue.patientLastName}
                  onChange={(e) => handleChange(e)}
                  placeholder="Please add a default"
                />
                <AddButton
                  onClick={() =>
                    isEmpty(defaultValue.patientLastName)
                      ? alert("Value required!")
                      : addDefaultHandler("row3")
                  }
                >
                  <span>Add</span>
                </AddButton>
              </PersonalizedFieldSection>
            </PersonalizedRow>
            <PersonalizedRow>
              <BottomContainer>
                <PersionalizedText>
                  {"{{patient_phone_number}}"}
                </PersionalizedText>
              </BottomContainer>
              <PersonalizedFieldSection>
                <InputField
                  type="text"
                  name="patientPhoneNumber"
                  value={defaultValue.patientPhoneNumber}
                  onChange={(e) => handleChange(e)}
                  placeholder="Please add a default"
                />
                <AddButton
                  onClick={() =>
                    isEmpty(defaultValue.patientPhoneNumber)
                      ? alert("Value required!")
                      : addDefaultHandler("row4")
                  }
                >
                 <span>Add</span>
                </AddButton>
              </PersonalizedFieldSection>
            </PersonalizedRow>
            <PersonalizedRow>
              <BottomContainer>
                <PersionalizedText>
                  {"{{patient_phone_number_type}}"}
                </PersionalizedText>
              </BottomContainer>
              <PersonalizedFieldSection>
                <InputField
                  type="text"
                  name="patientPhoneNumberType"
                  value={defaultValue.patientPhoneNumberType}
                  onChange={(e) => handleChange(e)}
                  placeholder="Please add a default"
                />
                <AddButton
                  onClick={() =>
                    isEmpty(defaultValue.patientPhoneNumberType)
                      ? alert("Value required!")
                      : addDefaultHandler("row5")
                  }
                >
                  <span>Add</span>
                </AddButton>
              </PersonalizedFieldSection>
            </PersonalizedRow>
            <PersonalizedRow>
              <BottomContainer>
                <PersionalizedText>
                  {"{{patient_language_preference}}"}
                </PersionalizedText>
              </BottomContainer>
              <PersonalizedFieldSection>
                <InputField
                  type="text"
                  name="patientLanguagePreference"
                  value={defaultValue.patientLanguagePreference}
                  onChange={(e) => handleChange(e)}
                  placeholder="Please add a default"
                />
                <AddButton
                  onClick={() =>
                    isEmpty(defaultValue.patientLanguagePreference)
                      ? alert("Value required!")
                      : addDefaultHandler("row6")
                  }
                >
                 <span>Add</span>
                </AddButton>
              </PersonalizedFieldSection>
            </PersonalizedRow>
            <PersonalizedRow>
              <BottomContainer>
                <PersionalizedText>{"{{patient_address}}"}</PersionalizedText>
              </BottomContainer>
              <PersonalizedFieldSection>
                <InputField
                  type="text"
                  name="patientAddress"
                  value={defaultValue.patientAddress}
                  onChange={(e) => handleChange(e)}
                  placeholder="Please add a default"
                />
                <AddButton
                  onClick={() =>
                    isEmpty(defaultValue.patientAddress)
                      ? alert("Value required!")
                      : addDefaultHandler("row7")
                  }
                >
                  <span>Add</span>
                </AddButton>
              </PersonalizedFieldSection>
            </PersonalizedRow>
            <PersonalizedRow>
              <BottomContainer>
                <PersionalizedText>{"{{patient_age}}"}</PersionalizedText>
              </BottomContainer>
              <PersonalizedFieldSection>
                <InputField
                  type="text"
                  name="patientAge"
                  value={defaultValue.patientAge}
                  onChange={(e) => handleChange(e)}
                  placeholder="Please add a default"
                />
                <AddButton
                  onClick={() =>
                    isEmpty(defaultValue.patientAge)
                      ? alert("Value required!")
                      : addDefaultHandler("row8")
                  }
                >
                  <span>Add</span>
                </AddButton>
              </PersonalizedFieldSection>
            </PersonalizedRow>
            <PersonalizedRow>
              <BottomContainer>
                <PersionalizedText>{"{{patient_email}}"}</PersionalizedText>
              </BottomContainer>
              <PersonalizedFieldSection>
                <InputField
                  type="text"
                  name="patientEmail"
                  value={defaultValue.patientEmail}
                  onChange={(e) => handleChange(e)}
                  placeholder="Please add a default"
                />
                <AddButton
                  onClick={() =>
                    isEmpty(defaultValue.patientEmail)
                      ? alert("Value required!")
                      : addDefaultHandler("row9")
                  }
                >
                  <span>Add</span>
                </AddButton>
              </PersonalizedFieldSection>
            </PersonalizedRow>

            <PersonalizedRow>
              <BottomContainer>
                <PersionalizedText>
                  {"{{referring_physician_first_name}}"}
                </PersionalizedText>
              </BottomContainer>
              <PersonalizedFieldSection>
                <InputField
                  type="text"
                  name="referringPhysicianFirstName"
                  value={defaultValue.referringPhysicianFirstName}
                  onChange={(e) => handleChange(e)}
                  placeholder="Please add a default"
                />
                <AddButton
                  onClick={() =>
                    isEmpty(defaultValue.referringPhysicianFirstName)
                      ? alert("Value required!")
                      : addDefaultHandler("row10")
                  }
                >
                  <span>Add</span>
                </AddButton>
              </PersonalizedFieldSection>
            </PersonalizedRow>
            <PersonalizedRow>
              <BottomContainer>
                <PersionalizedText>
                  {"{{referring_physician_last_name}}"}
                </PersionalizedText>
              </BottomContainer>
              <PersonalizedFieldSection>
                <InputField
                  type="text"
                  name="referringPhysicianLastName"
                  value={defaultValue.referringPhysicianLastName}
                  onChange={(e) => handleChange(e)}
                  placeholder="Please add a default"
                />
                <AddButton
                  onClick={() =>
                    isEmpty(defaultValue.referringPhysicianLastName)
                      ? alert("Value required!")
                      : addDefaultHandler("row11")
                  }
                >
                  <span>Add</span>
                </AddButton>
              </PersonalizedFieldSection>
            </PersonalizedRow>

            <PersonalizedRow>
              <BottomContainer>
                <PersionalizedText>
                  {"{{referring_physician_email}}"}
                </PersionalizedText>
              </BottomContainer>
              <PersonalizedFieldSection>
                <InputField
                  type="text"
                  name="referringPhysicianEmail"
                  value={defaultValue.referringPhysicianEmail}
                  onChange={(e) => handleChange(e)}
                  placeholder="Please add a default"
                />
                <AddButton
                  onClick={() =>
                    isEmpty(defaultValue.referringPhysicianEmail)
                      ? alert("Value required!")
                      : addDefaultHandler("row12")
                  }
                >
                  <span>Add</span>
                </AddButton>
              </PersonalizedFieldSection>
            </PersonalizedRow>
            <PersonalizedRow>
              <BottomContainer>
                <PersionalizedText>
                  {"{{referring_physician_unique_id}}"}
                </PersionalizedText>
              </BottomContainer>
              <PersonalizedFieldSection>
                <InputField
                  type="text"
                  name="referringPhysicianUniqueId"
                  value={defaultValue.referringPhysicianUniqueId}
                  onChange={(e) => handleChange(e)}
                  placeholder="Please add a default"
                />
                <AddButton
                  onClick={() =>
                    isEmpty(defaultValue.referringPhysicianUniqueId)
                      ? alert("Value required!")
                      : addDefaultHandler("row13")
                  }
                >
                  <span>Add</span>
                </AddButton>
              </PersonalizedFieldSection>
            </PersonalizedRow>
            <PersonalizedRow>
              <BottomContainer>
                <PersionalizedText>
                  {"{{referring_physician_fax}}"}
                </PersionalizedText>
              </BottomContainer>
              <PersonalizedFieldSection>
                <InputField
                  type="text"
                  name="referringPhysicianFax"
                  value={defaultValue.referringPhysicianFax}
                  onChange={(e) => handleChange(e)}
                  placeholder="Please add a default"
                />
                <AddButton
                  onClick={() =>
                    isEmpty(defaultValue.referringPhysicianFax)
                      ? alert("Value required!")
                      : addDefaultHandler("row14")
                  }
                >
                  <span>Add</span>
                </AddButton>
              </PersonalizedFieldSection>
            </PersonalizedRow>
            <PersonalizedRow>
              <BottomContainer>
                <PersionalizedText>
                  {"{{referring_physician_phone_number}}"}
                </PersionalizedText>
              </BottomContainer>
              <PersonalizedFieldSection>
                <InputField
                  type="text"
                  name="referringPhysicianPhoneNumber"
                  value={defaultValue.referringPhysicianPhoneNumber}
                  onChange={(e) => handleChange(e)}
                  placeholder="Please add a default"
                />
                <AddButton
                  onClick={() =>
                    isEmpty(defaultValue.referringPhysicianPhoneNumber)
                      ? alert("Value required!")
                      : addDefaultHandler("row15")
                  }
                >
                  <span>Add</span>
                </AddButton>
              </PersonalizedFieldSection>
            </PersonalizedRow>

            <PersonalizedRow>
              <BottomContainer>
                <PersionalizedText>
                  {"{{report_modality}}"}
                </PersionalizedText>
              </BottomContainer>
              <PersonalizedFieldSection>
                <InputField
                  type="text"
                  name="reportModality"
                  value={defaultValue.reportModality}
                  onChange={(e) => handleChange(e)}
                  placeholder="Please add a default"
                />
                <AddButton
                  onClick={() =>
                    isEmpty(defaultValue.reportModality)
                      ? alert("Value required!")
                      : addDefaultHandler("row16")
                  }
                >
                 <span>Add</span>
                </AddButton>
              </PersonalizedFieldSection>
            </PersonalizedRow>
            <PersonalizedRow>
              <BottomContainer>
                <PersionalizedText>
                  {"{{report_exam_date}}"}
                </PersionalizedText>
              </BottomContainer>
              <PersonalizedFieldSection>
                <InputField
                  type="text"
                  name="reportExamDate"
                  value={defaultValue.reportExamDate}
                  onChange={(e) => handleChange(e)}
                  placeholder="Please add a default"
                />
                <AddButton
                  onClick={() =>
                    isEmpty(defaultValue.reportExamDate)
                      ? alert("Value required!")
                      : addDefaultHandler("row17")
                  }
                >
                  <span>Add</span>
                </AddButton>
              </PersonalizedFieldSection>
            </PersonalizedRow>
            <PersonalizedRow>
              <BottomContainer>
                <PersionalizedText>
                  {"{{report_radiologist_first_name}}"}
                </PersionalizedText>
              </BottomContainer>
              <PersonalizedFieldSection>
                <InputField
                  type="text"
                  name="reportRadiologistFirstName"
                  value={defaultValue.reportRadiologistFirstName}
                  onChange={(e) => handleChange(e)}
                  placeholder="Please add a default"
                />
                <AddButton
                  onClick={() =>
                    isEmpty(defaultValue.reportRadiologistFirstName)
                      ? alert("Value required!")
                      : addDefaultHandler("row18")
                  }
                >
                  <span>Add</span>
                </AddButton>
              </PersonalizedFieldSection>
            </PersonalizedRow>
            <PersonalizedRow>
              <BottomContainer>
                <PersionalizedText>
                  {"{{report_radiologist_last_name}}"}
                </PersionalizedText>
              </BottomContainer>
              <PersonalizedFieldSection>
                <InputField
                  type="text"
                  name="reportRadiologistLastName"
                  value={defaultValue.reportRadiologistLastName}
                  onChange={(e) => handleChange(e)}
                  placeholder="Please add a default"
                />
                <AddButton
                  onClick={() =>
                    isEmpty(defaultValue.reportRadiologistLastName)
                      ? alert("Value required!")
                      : addDefaultHandler("row19")
                  }
                >
                  <span>Add</span>
                </AddButton>
              </PersonalizedFieldSection>
            </PersonalizedRow>
            <PersonalizedRow>
              <BottomContainer>
                <PersionalizedText>
                  {"{{recommendation_modality}}"}
                </PersionalizedText>
              </BottomContainer>
              <PersonalizedFieldSection>
                <InputField
                  type="text"
                  name="recommendationModality"
                  value={defaultValue.recommendationModality}
                  onChange={(e) => handleChange(e)}
                  placeholder="Please add a default"
                />
                <AddButton
                  onClick={() =>
                    isEmpty(defaultValue.recommendationModality)
                      ? alert("Value required!")
                      : addDefaultHandler("row20")
                  }
                >
                  <span>Add</span>
                </AddButton>
              </PersonalizedFieldSection>
            </PersonalizedRow>

            <PersonalizedRow>
              <BottomContainer>
                <PersionalizedText>
                  {"{{recommendation_anatomy}}"}
                </PersionalizedText>
              </BottomContainer>
              <PersonalizedFieldSection>
                <InputField
                  type="text"
                  name="recommendationAnatomy"
                  value={defaultValue.recommendationAnatomy}
                  onChange={(e) => handleChange(e)}
                  placeholder="Please add a default"
                />
                <AddButton
                  onClick={() =>
                    isEmpty(defaultValue.recommendationAnatomy)
                      ? alert("Value required!")
                      : addDefaultHandler("row21")
                  }
                >
                  <span>Add</span>
                </AddButton>
              </PersonalizedFieldSection>
            </PersonalizedRow>

            <PersonalizedRow>
              <BottomContainer>
                <PersionalizedText>
                  {"{{recommendation_range_start}}"}
                </PersionalizedText>
              </BottomContainer>
              <PersonalizedFieldSection>
                <InputField
                  type="text"
                  name="recommendationRangeStart"
                  value={defaultValue.recommendationRangeStart}
                  onChange={(e) => handleChange(e)}
                  placeholder="Please add a default"
                />
                <AddButton
                  onClick={() =>
                    isEmpty(defaultValue.recommendationRangeStart)
                      ? alert("Value required!")
                      : addDefaultHandler("row22")
                  }
                >
                  <span>Add</span>
                </AddButton>
              </PersonalizedFieldSection>
            </PersonalizedRow>
            <PersonalizedRow>
              <BottomContainer>
                <PersionalizedText>
                  {"{{recommendation_range_end}}"}
                </PersionalizedText>
              </BottomContainer>
              <PersonalizedFieldSection>
                <InputField
                  type="text"
                  name="recommendationRangeEnd"
                  value={defaultValue.recommendationRangeEnd}
                  onChange={(e) => handleChange(e)}
                  placeholder="Please add a default"
                />
                <AddButton
                  onClick={() =>
                    isEmpty(defaultValue.recommendationRangeEnd)
                      ? alert("Value required!")
                      : addDefaultHandler("row23")
                  }
                >
                 <span>Add</span>
                </AddButton>
              </PersonalizedFieldSection>
            </PersonalizedRow>
      
          </InsertPersonalizedSection>
        ) : null}
      </CreateTemplateContainer>
    </>
  );
};

export const TemplateButton = ({
  icon,
  title,
  color,
  hoverBg,
  isHover = false,
  clickHandler,
  width,
  style = {},
  iconContainerStyles = {},
  textStyles = {},
  border = false,
  outlinedBr = "",
}) => {
  return (
    <>
      <ButtonContainer
        color={color}
        onClick={clickHandler}
        width={width ? 125 : 120}
        style={style}
        border={border}
        outlinedBr={outlinedBr}
        hoverBg={hoverBg}
        isHover={isHover}
      >
        <Text textcolor={color} style={textStyles}>
          {title}
        </Text>
      </ButtonContainer>
    </>
  );
};
